"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _moment = _interopRequireDefault(require("moment"));

var DatePicker = function DatePicker(props) {
  var value = props.value,
      defaultValue = props.defaultValue,
      _props$format = props.format,
      format = _props$format === void 0 ? 'DD/MM/YYYY' : _props$format,
      _onChange = props.onChange;
  (0, _react.useEffect)(function () {
    if (!value && !defaultValue) {
      // Add fallback date in case no value or default value is provided
      var now = new Date();
      var formattedDate = (0, _moment.default)(now).format(format);

      _onChange(formattedDate);
    }
  }, [value, defaultValue]);
  return /*#__PURE__*/_react.default.createElement("div", null, value || defaultValue && /*#__PURE__*/_react.default.createElement(_antd.DatePicker, {
    value: (0, _moment.default)(value || defaultValue, format),
    onChange: function onChange(value) {
      return _onChange(value ? value._d : '');
    },
    allowClear: false,
    style: {
      width: '100%'
    }
  }));
};

var _default = DatePicker;
exports.default = _default;